module.exports = __webpack_public_path__ + "static/media/Cat_astronaut.b483ad19.jpg";